import React, { useEffect, useState } from "react";
import { useSnackbar } from "../../hook/useSnackbar";
import { getAllAplicaciones } from "../../utils/AplicacionesUtils";

export default function InputSelectComponent({ props, register, setValue }) {
    const [listOpt, setListOpt] = useState([]);
    const { showSnackbar } = useSnackbar();
    const prefix_Field = props?.type === "choice" ? '' : 'LookupId'

    useEffect(() => {
        // Para el campo aplicacion_busint, cargar desde JSON con IDs correctos
        if (props.name === 'aplicacion_busint' && listOpt.length === 0) {
            const aplicaciones = getAllAplicaciones();
            const options = aplicaciones.map(app => ({
                id: app.id,
                [props.lookup?.columnName || 'Title']: app.label
            }));
            setListOpt(options);
        }
        // Para campos lookup con opciones definidas en choice.choices
        else if (props.type === "lookup" && props.choice && props.choice.choices && listOpt.length === 0) {
            const options = props.choice.choices.map((choice, index) => ({
                id: index + 1,
                [props.lookup?.columnName || 'Title']: choice
            }));
            setListOpt(options);
        }
        // Advertencia si el lookup no tiene opciones configuradas (excepto aplicacion_busint)
        else if (props.type === "lookup" && (!props.choice || !props.choice.choices) && props.name !== 'aplicacion_busint') {
            console.warn(`El campo lookup "${props.name}" no tiene opciones definidas en choice.choices. Configúralas en estructuraFormularios.json`);
        }

        return () => {}
    }, [])

    const selectProps = {
        name: props.name + prefix_Field,
        id: props.id,
        ...(props.required ? { required: true } : {}),
        ...register(props.name + prefix_Field, {
            value: props?.defaultValue?.value
        })
    };


    return (
        props.hidden ? <></> :
            <div >
                <label htmlFor="">
                    {props.displayName}
                    <span>{props.description}</span>
                </label>
                <select {...selectProps}>
                    <option value="" key={props.id + 'empty'}></option>
                    {
                        props.type === "choice" ?
                            props.choice.choices.map((item, index) => <option value={item} key={props.id + '__' + index} >{item}</option>) :
                            listOpt.map(result => <option value={result.id} key={props.id + result.id} >{result[props.lookup?.columnName || 'Title']}</option>)
                    }
                </select>
                {props.required ? <span className='error-message'>Debes elegir {props.displayName}</span> : <></>}
            </div>
    )
}